import { Component, OnInit } from '@angular/core';
import { HomeService } from './home.service';

import { Grafico } from '../shared/model/chart.model';
import { AuthService } from '../seguranca/auth.service';
import { GraficoSearchParameter } from '../shared/model/search/graficos-search-parameters.model';
import { ToastrService } from 'ngx-toastr';

@Component({templateUrl: './home.component.html', styleUrls: ['./home.component.css']})
export class HomeComponent implements OnInit {

  chartDataAno: Grafico;
  chartDataMes: Grafico;

  filters: GraficoSearchParameter;

  qtdeAtendimentos: number;
  qtdeProcedimentos: number;
  qtdePrestadores: number;
  qtdeUsuarios: number;

  configCounter: any;

  constructor(private homeService: HomeService, private authService: AuthService, private toast: ToastrService) {
    this.configCounter = {
      startVal: 1,
      duration: 2,
      useGrouping: false
    };
  }

  ngOnInit() {
    this.filters = new GraficoSearchParameter();

    // Setar o ano atual para exibir os dados.
    this.filters.ano = new Date().getFullYear();

    // Caso seja um usuário final passar o seu id para buscar os dados.
    if (this.authService.getLoggedUser().perfil === 1 || this.authService.getLoggedUser().perfil === 4) {
      this.filters.usuario = this.authService.getLoggedUser().id;
      console.log(this.authService.getLoggedUser().perfil);
      console.log(this.filters.usuario);
    } else {
      // Buscar os dados para preencher os cards.
      this.buscarQuantidadeGeralAtendimentos();
      this.buscarQuantidadeGeralProcedimentos();
      this.buscarQuantidadeGeralPrestadores();
      this.buscarQuantidadeGeralUsuarios();
    }

    // Método para chamar o gráfico mensal.
    this.gerarGraficoQuantidadeMensal();

    // Método para chamar o gráfico anual.
    this.gerarGraficoQuantidadeAnual();
  }

  // Método responsável por buscar a quantidade geral dos atendimentos.
  private buscarQuantidadeGeralAtendimentos() {
    this.homeService.buscarQuantidadeAtendimentos().subscribe(
      (dados) => this.qtdeAtendimentos = dados,
      (error) => this.toast.error('Erro ao processar, tente novamente!')
    );
  }

  // Método responsável por buscar a quantidade geral de procedimentos
  private buscarQuantidadeGeralProcedimentos() {
    this.homeService.buscarQuantidadeProcedimentos().subscribe(
      (dados) => this.qtdeProcedimentos = dados,
      (error) => this.toast.error('Erro ao processar, tente novamente!')
    );
  }

  // Método responsável por buscar a quantidade geral de prestadores
  private buscarQuantidadeGeralPrestadores() {
    this.homeService.buscarQuantidadePrestadores().subscribe(
      (dados) => this.qtdePrestadores = dados,
      (error) => this.toast.error('Erro ao processar, tente novamente!')
    );
  }

  // Método responsável por buscar a quantidade geral de usuários
  private buscarQuantidadeGeralUsuarios() {
    this.homeService.buscarQuantidadeUsuarios().subscribe(
      (dados) => this.qtdeUsuarios = dados,
      (error) => this.toast.error('Erro ao processar, tente novamente!')
    );
  }

  // Método responsável por montar o gráfico de quantidade anual dos atendimentos.
  private gerarGraficoQuantidadeMensal() {
    this.homeService.buscarQuantidadeAtendimentosPorMes(this.filters).subscribe(
      (dados) => {

        this.chartDataMes = new Grafico();

        // Tipo do gráfico
        // this.chartDataMes.tipo = 'line';

        // Labels do gráfico
        this.chartDataMes.labels = dados.map(value => {
          return this.filters.getMes(value.mesAtendimento);
        });

        // Valores plotados nos gráficos.
        this.chartDataMes.values = dados.map(value => value.quantidade);

        this.chartDataMes.titulo = 'Quantidade';

        // Definir cores do gráfico
        this.chartDataMes.backgroundColor = '#2e74ba';
        this.chartDataMes.hoverBackgroundColor = '#0000FF';

        this.chartDataMes.tituloEixoY = '';
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

  // Método responsável por montar o gráfico de quantidade anual dos atendimentos.
  private gerarGraficoQuantidadeAnual() {
    this.homeService.buscarQuantidadeAtendimentosPorAno(this.filters).subscribe(
      (dados) => {

        this.chartDataAno = new Grafico();

        // Labels do gráfico
        this.chartDataAno.labels = dados.map(value => value.ano);

        // Valores plotados nos gráficos.
        this.chartDataAno.values = dados.map(value => value.quantidade);

        this.chartDataAno.titulo = 'Quantidade';

        // Definir cores do gráfico
        this.chartDataAno.backgroundColor = '#FFD700';
        this.chartDataAno.hoverBackgroundColor = '#FFFF00';

        this.chartDataAno.tituloEixoY = '';
      },
      error => this.toast.error('Erro ao processar o gráfico, tente novamente!')
    );
  }

  /**
   * Método responsável por exibir os cards.
   */
  isVisible() {
    return this.authService.getLoggedUser().perfil !== 1 && this.authService.getLoggedUser().perfil !== 4;
  }
}
